'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _cmsComponentUtilities = require('@viskan/cms-component-utilities');

var _dekuForm = require('@viskan/deku-form');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /** @jsx dom */


var name = 'CMS-Component-MessageForm-Field';

var propTypes = {
	getTranslation: {
		source: 'getTranslation'
	},
	validationError: {
		source: 'validationError'
	}
};

var getCompareValue = function getCompareValue(rule, props) {
	switch (rule) {
		case 'zipCode':
		case 'ssn':
		case 'cin':
		case 'phone':
			{
				return props.countryCode;
			}
		case 'exactLength':
		case 'greaterThan':
		case 'greaterThanEqual':
		case 'lowerThan':
		case 'lowerThanEqual':
		case 'maxLength':
		case 'minLength':
			{
				return parseInt(props.validationCompareValue, 10);
			}
		case 'regex':
			{
				return RegExp(props.validationCompareValue, 'g');
			}
		default:
			{
				return props.validationCompareValue || '';
			}
	}
};

var validate = function validate(props) {
	return function (value) {
		var compareValue = getCompareValue(props.validation, props);

		return v12.validation(value, _defineProperty({}, props.validation, compareValue));
	};
};

var renderField = function renderField(props, componentProps) {
	switch (props.type) {
		case 'textarea':
			{
				return (0, _magicVirtualElement2.default)(_dekuForm.TextField, _extends({ multiline: true }, componentProps, { maxLength: parseInt(props.textAreaMaxLength, 10) }));
			}
		case 'checkbox':
			{
				return (0, _magicVirtualElement2.default)(_dekuForm.CheckboxField, _extends({}, componentProps, { value: 'true' }));
			}
		case 'radio':
			{
				return (0, _magicVirtualElement2.default)(_dekuForm.RadioField, componentProps);
			}
		default:
			{
				return (0, _magicVirtualElement2.default)(_dekuForm.InputField, componentProps);
			}
	}
};

var render = function render(_ref) {
	var props = _ref.props;

	var componentProps = {
		type: props.type,
		name: props.name,
		label: (0, _magicVirtualElement2.default)(
			'div',
			null,
			(0, _magicVirtualElement2.default)(
				'span',
				null,
				props.label
			),
			props.required && (0, _magicVirtualElement2.default)(
				'span',
				{ 'class': 'FormField-required' },
				'*'
			)
		),
		hint: props.hint,
		placeholder: props.placeholder,
		required: props.required,
		rules: props.validation && validate(props),
		value: props.value,
		validate: ['onBlur'],
		validationMessage: props.validationError(props.label, props.getTranslation)
	};

	return (0, _cmsComponentUtilities.createCmsComponent)((0, _magicVirtualElement2.default)(
		'div',
		{ 'class': [name, props.styleClasses.Wrapper], 'data-style-attr': 'Wrapper' },
		renderField(props, componentProps)
	), props);
};

exports.default = { render: render, name: name, propTypes: propTypes };